import { render, staticRenderFns } from "./InsufficientBalance.vue?vue&type=template&id=73af4766"
import script from "./InsufficientBalance.vue?vue&type=script&lang=js"
export * from "./InsufficientBalance.vue?vue&type=script&lang=js"
import style0 from "./InsufficientBalance.vue?vue&type=style&index=0&id=73af4766&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports